import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { environment } from 'src/environments/environment';

@Injectable({
  providedIn: 'root'
})
export class ScaleNoteService {

  private URL = environment.api + "api/erp/scale-notes";
  
    constructor(private http: HttpClient) { }

  getScalesNoteAll() {
    return this.http.get(this.URL);
  }

  getScaleNote() {
    return this.http.get(this.URL + "");
  }

  getScaleNoteById(id) {
    return this.http.get(this.URL + `/${id}`);
  }

  createScaleNote(request) {
    return this.http.post(this.URL, request);
  }

  updateScaleNote(id, request) {
    return this.http.put(this.URL + `/${id}`, request);
  }

  deleteScaleNote(id) {
    return this.http.delete(this.URL + `/${id}`);
  }

  getScaleNoteDetails(id) {
    return this.http.get(this.URL + `/details/${id}`);
  }
}
